import React, { PureComponent as Component } from "react";
import * as CampaignTaskActions from "actions/campaign-task-actions";
import * as DialogActions from "actions/dialog-actions";
import * as SmsActions from "actions/sms-actions";
import * as socialActionsActions from "actions/social-actions-actions";
import CalendarPageContainer from "components/calendar/CalendarPageContainer";
import CreateCampaignLimitModal from "components/campaigns/CreateCampaignLimitModal";
import OverviewActionsContainer from "components/partnerships/OverviewActionsContainer";
import OverviewTheme from "css/themes/Overview.css";
import CampaignDispatcher from "dispatchers/campaign-dispatcher";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Spinner from "util/components/spinner";
import Announcements from "visual-components/campaignOverview/Announcements";
// import ESPIntegrationCard from "visual-components/campaignOverview/ESPIntegrationCard";
import EmailDelivery from "visual-components/campaignOverview/EmailDelivery";
import GrowOptimize from "visual-components/campaignOverview/GrowOptimize";
import LinksFiles from "visual-components/campaignOverview/LinksFiles";
// sections
import Quickview from "visual-components/campaignOverview/Quickview";
import MobileMarketingProvider from "visual-components/mobile-marketing/MobileMarketingContext";
import WinnerModal from "visual-components/myPartnerships/winner-modal";
import Col from "visual-components/util/no-padding-grid/col";
import Grid from "visual-components/util/no-padding-grid/grid";
import Row from "visual-components/util/no-padding-grid/row";
import { H2 } from "visual-components/util/texts";
import OverviewNav from "./OverviewNav";
import SoloOverview from "./SoloOverview";

const mapStateToProps = ({ currentCampaign, currentBrand, sms }) => ({
  currentCampaign,
  currentBrand,
  sms,
});

const mapDispatchToProps = (dispatch) => ({
  smsActions: bindActionCreators(SmsActions, dispatch),
  campaignTaskActions: bindActionCreators(CampaignTaskActions, dispatch),
  dialogActions: bindActionCreators(DialogActions, dispatch),
  socialActionsActions: bindActionCreators(socialActionsActions, dispatch),
});

class CampaignOverview extends Component {
  static contextTypes = {
    launchCampaign: PropTypes.func,
    currentBrand: PropTypes.object.isRequired,
    currentCampaign: PropTypes.object.isRequired,
  };
  state = {
    winnerModal: false,
  };
  componentDidMount() {
    const {
      match: {
        params: { campaignId },
      },
      campaignTaskActions: { load },
      sms,
      smsActions,
      currentBrand,
    } = this.props;

    CampaignDispatcher.loadRequest(campaignId);
    load(campaignId);
    if (sms.loading) smsActions.fetchBrandBank(currentBrand.id);
  }

  goTo = (location) => {
    const { history } = this.props;
    history.push(locationMap[location]);
  };

  chooseWinner = async () => {
    this.setState({
      winnerLoading: false,
    });
    CampaignDispatcher.chooseWinner(() => {
      toastr.success(
        "<div style='text-align:left; line-height:1.5; font-size:14px;'>\
          <strong>Your request has been successfully submitted!</strong><br><br>\
          Please check back soon (5-10 minutes) and we will update this page once the winner has been selected. \
          Be advised, processing may take some time, as Dojo will verify the entries and review for accuracy.<br><br>\
          <span style='font-weight:bold; color:#ffeb3b;'>Please DO NOT refresh the page multiple times</span>, \
          if the winner is not displayed, check back again after 10 minutes.<br><br>\
          Should you have any inquiries, kindly contact us at \
          <a href='mailto:hello@dojomojo.com' style='color:#90caf9; text-decoration:underline;'>hello@dojomojo.com</a>.\
        </div>",
        {
          timeOut: 10000,
          positionClass: "toast-bottom-center",
          closeButton: true,
          escapeHtml: false,
        },
      );
      this.setState({ winnerModal: false, winnerLoading: false });
    });
  };
  closeWinnerModal = () => {
    this.setState({
      winnerModal: false,
    });
  };
  launchCampaign = () => {
    const { launchCampaign } = this.context;
    const { currentCampaign, dialogActions } = this.props;
    const {
      campaignTerms: [campaignTerms],
      id,
      name,
      isSolo,
    } = currentCampaign;
    const hasTerms =
      campaignTerms && campaignTerms.termsPublishedAt && campaignTerms.termsStatus === "published";
    return hasTerms
      ? launchCampaign(id, isSolo)
      : dialogActions.openDialogWithPayload("incompleteRulesModal", { name, id });
  };

  render() {
    const { currentCampaign, currentBrand, sms } = this.props;
    const prefix = this.props.match.path;
    const prefixedUrl = this.props.match.url;

    const { winnerModal } = this.state;

    if (currentCampaign.loading || this.state.winnerLoading || sms.loading) {
      return <Spinner />;
    }

    if (currentCampaign.isSolo) {
      return (
        <SoloOverview
          currentCampaign={currentCampaign}
          currentBrand={currentBrand}
          winnerModalOpen={winnerModal}
          closeWinnerModal={this.closeWinnerModal}
          chooseWinner={this.chooseWinner}
          launchCampaign={this.launchCampaign}
        />
      );
    }

    return (
      <>
        <div className={`${OverviewTheme.overviewContainer} ${OverviewTheme.overviewContainerNav}`}>
          <div className={OverviewTheme.overviewWrapper}>
            <Helmet>
              <title>Campaign Overview</title>
            </Helmet>
            <Grid>
              <Row style={{ marginBottom: "24px" }}>
                <Col xs={7}>
                  <div style={{ display: "inline-block" }}>
                    <H2 azure>{currentCampaign.name}</H2>
                  </div>
                </Col>
                <OverviewActionsContainer
                  currentCampaign={currentCampaign}
                  pickWinner={this.chooseWinner}
                  onLaunchCampaign={this.launchCampaign}
                />
              </Row>
              <Row>
                <Col xs={12}>
                  <Route
                    path={`${prefix}/:selected`}
                    render={({ match }) => (
                      <OverviewNav prefixedUrl={prefixedUrl} selected={match.params.selected} />
                    )}
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
        <div className={OverviewTheme.overviewContainer}>
          <div className={OverviewTheme.overviewWrapper}>
            <Switch>
              <Route path={`${prefix}/quickview`} component={Quickview} />
              <Route path={`${prefix}/calendar`} component={CalendarPageContainer} />
              <Route path={`${prefix}/announcements`} component={Announcements} />
              <Route path={`${prefix}/links-files`} component={LinksFiles} />
              <Route
                path={`${prefix}/email-delivery/:section?/:subsection?`}
                component={EmailDelivery}
              />
              <Route path={`${prefix}/grow-optimize`} component={GrowOptimize} />
              <Redirect to="/404" />
            </Switch>
          </div>
        </div>
        <WinnerModal
          isOpen={winnerModal}
          currentCampaign={currentCampaign}
          hideModal={this.closeWinnerModal}
        />
        <CreateCampaignLimitModal />
      </>
    );
  }
}

// Workaround to make contextType work with connect
// Source: https://github.com/reduxjs/react-redux/issues/1067
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )((props) => (
    <MobileMarketingProvider>
      <CampaignOverview {...props} />
    </MobileMarketingProvider>
  )),
);
